export const constructionImage = require('./constructionImage.jpg');

export const noDataImage = require('./noData.jpg');
export const noDataImage2 = require('./noData2.png');
export const noImage = require('./noImage.jpg');
export const noImage2 = require('./noImage2.png');

export const loadingGif = require('./loading.gif');
export const logo = require('./logo.jpg');
